export const PUBLIC_KEY = 'BLwyeX20Hb8mXigGRApIJh2GbeNmCWgYPf_0-_7L0cel1a7GzdfSxSaOUFoLg5n4TcXlhtK0yntOhKJy5OtHw2M'
export const MOVING_MARKER = require("@/assets/images/movingTaxi.svg")

export const STATE_DESCRIPTIONS = {
    200: "Tu taxi fue asignado",
    540: "Te recogimos",
    900: "Tu servicio finalizó"
}
export const STATE_ICONS = {
    100: require("@/assets/images/movingTaxi.svg"),
    200: require("@/assets/images/service_resume/circle_blue.svg"),
    540: require("@/assets/images/service_resume/circle_orange.svg"),
    900: require("@/assets/images/service_resume/circle_green.svg")
}
export const ASSIGNED_TAXI = 200
export const POSITIVE_TAXI = 540
export const FINISHED_TAXI = 900





